import { initFetch } from '@/router/guard/fetch'

const reloaded = ref(true)
export function useLayout() {
  function reloadPage() {
    reloaded.value = false
    nextTick(() => {
      reloaded.value = true
      initFetch()
    })
  }
  return {
    reloaded,
    reloadPage,
  }
}

export function removeHtmlLoading() {
  const loading = document.getElementById('lottie-loading')
  const lottie = document.getElementById('lottie')
  const left = document.querySelector('.lottie-left')
  const right = document.querySelector('.lottie-right')

  left && (left.className += ' left-leave')
  right && (right.className += ' right-leave')
  lottie && (lottie.className += ' scale-leave')

  setTimeout(() => {
    loading?.remove()
  }, 1000)
}
